import { AppStorage } from '@/shared/constants/app-storage.constant';

const COLLAPSED_VALUE = 'Collapsed';

// Read on every call: the sidebar remounts on domain change and must get the latest state
export const getSidebarCollapsed = () => Boolean(localStorage.getItem(AppStorage.Sidebar));

export const setSidebarCollapsed = (collapsed: boolean) => {
	localStorage.setItem(AppStorage.Sidebar, collapsed ? COLLAPSED_VALUE : '');
};
